import React from 'react';

/** Lazy ClientComputedContentFilter (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedContentFilter = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-content-filter' */
            './ClientComputedContentFilter'
        ),
);
